import React, { useContext, useState } from "react";
import { apiPut, apiDelete } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import { isEmpty, startCase } from "lodash";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
import AuthContext from "context/AuthContext";
import { useTranslation } from "react-i18next";
import useToastContext from "hooks/useToastContext";
import helper from "../../utils/helpers";
import { BsArrowUpShort } from "react-icons/bs";

const Table = ({
  FAQs,
  getAllFAQ,
  handelEdit,
  paginationObj,
  sort,
  setSort,
  manager,
}) => {
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);
  const notification = useToastContext();
  const [deleteFAQsModal, setDeleteFAQsModal] = useState(false);
  const [selctAllCheck, setSelectAllCheck] = useState(false);
  const [selectedFAQs, setSelectedFAQs] = useState([]);
  const handelStatusChange = async (item) => {
    try {
      const payload = {
        status: item?.status === "inactive" ? "active" : "inactive",
      };
      const path = `${apiPath.changeFAQStatus}/${item?._id}`;
      const result = await apiPut(path, payload);
      if (result?.status === 200) {
        notification.success(result.data.message);
        getAllFAQ();
      }
      // }
    } catch (error) {
      console.log("error in get all faqs list==>>>>", error.message);
    }
  };

  const handelDelete = async (item) => {
    try {
      const path = apiPath.getFAQs + "/" + item?._id;
      const result = await apiDelete(path);
      if (result?.status === 200) {
        getAllFAQ({ deletePage: 1 });
      }
    } catch (error) {
      console.log("error in get all FAQs list==>>>>", error.message);
    }
  };

  const selctAllHandler = () => {
    setSelectAllCheck(!selctAllCheck);
    if (selectedFAQs?.length === FAQs?.length) {
      setSelectedFAQs([]);
    } else setSelectedFAQs(FAQs?.map((res) => res));
  };

  const selectHandler = (data) => {
    const isExists = selectedFAQs?.find((res) => res?._id === data?._id);
    if (!isExists) {
      setSelectedFAQs([...selectedFAQs, data]);
    } else {
      setSelectedFAQs(selectedFAQs.filter((item) => item?._id !== data?._id));
    }
  };

  async function deleteFAQs() {
    if (!selectedFAQs?.length) return;
    setDeleteFAQsModal(true);
  }

  async function unitsModalChangeHandler(isDelete) {
    if (isDelete)
      try {
        const requests = selectedFAQs.map((faq) =>
          apiDelete(apiPath.getFAQs + "/" + faq?._id),
        );
        await Promise.all(requests);
        notification.success("FAQs delete Successfully");
      } catch (error) {
        notification.error("Something went wrong, please try again later");
      }
    setDeleteFAQsModal(false);
    setSelectedFAQs([]);
    await getAllFAQ();
  }

  return (
    <div className="p-3">
      <div>
        {selectedFAQs?.length && manager.delete ? (
          <button
            onClick={deleteFAQs}
            type="button"
            className="bg-red-500 text-sm px-8 mb-3 py-2 text-white rounded-lg  border border-transparent  hover:bg-red-600 flex items-center justify-center gap-2 sm:w-auto w-1/2"
          >
            <AiFillDelete className="w-5 h-5 text-white" />
            <span>DeleteFAQs</span>
          </button>
        ) : null}
      </div>
      <div
        className="overflow-x-auto relative 
 border"
      >
        <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
          <thead className="text-xs text-gray-900 border border-[#E1E6EE]  bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="py-3 px-6">
                <input
                  type="checkbox"
                  id="check"
                  name="selectAll"
                  checked={selctAllCheck}
                  onChange={() => selctAllHandler()}
                />
              </th>
              <th scope="col" className="py-3 px-6">
                #
              </th>
              <th scope="col" className="py-3 px-6">
                {t("PROJECT")}
              </th>
              <th scope="col" className="py-3 px-6">
                {t("FAQS_TITLE")}
              </th>
              <th scope="col" className="py-3 px-6">
                {t("FAQS_TITLE") + t("O_ARABIC")}
              </th>
              <th scope="col" className="py-3 px-6">
                {t("FAQS_CAETGORY")}
              </th>
              <th
                scope="col"
                className="py-3 px-1 cursor-pointer"
                onClick={() => {
                  if (
                    sort.sort_key === "createdAt" &&
                    sort.sort_type === "asc"
                  ) {
                    setSort({
                      sort_key: "createdAt",
                      sort_type: "desc",
                    });
                  } else {
                    setSort({
                      sort_key: "createdAt",
                      sort_type: "asc",
                    });
                  }
                }}
              >
                <div className="flex justify-end">
                  <span>{t("O_CREATED_AT")}</span>
                  <span>
                    {sort.sort_key === "createdAt" &&
                      sort.sort_type === "asc" && (
                        <BsArrowUpShort className="w-4 h-4" />
                      )}
                    {sort.sort_key === "createdAt" &&
                      sort.sort_type === "desc" && (
                        <BsArrowUpShort className="w-4 h-4 rotate-180" />
                      )}
                  </span>
                </div>
              </th>
              {/* <th scope='col' className='py-3 px-6 text-right'>
                {t('O_CREATED_AT')}
              </th> */}
              <th scope="col" className="py-3 px-6 text-right">
                {t("O_UPDATE_DATE")}
              </th>
              {(manager?.add || user?.role === "admin") && (
                <>
                  <th scope="col" className="py-3 px-6 text-center">
                    {t("O_STATUS")}
                  </th>
                  <th scope="col" className="py-3 px-6 text-center">
                    {t("O_ACTION")}
                  </th>
                </>
              )}
            </tr>
          </thead>
          <tbody>
            {FAQs &&
              FAQs?.map((item, i) => (
                <tr
                  key={i}
                  className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                >
                  <th
                    scope="row"
                    className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                  >
                    <input
                      type="checkbox"
                      id="check"
                      name="unit"
                      value={item?._id}
                      checked={selectedFAQs.find(
                        (res) => res?._id === item?._id,
                      )}
                      onChange={() => selectHandler(item)}
                    />
                  </th>
                  <th
                    scope="row"
                    className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                  >
                    {i + 1 + 10 * (paginationObj?.page - 1)}
                  </th>
                  <td className="py-2 px-2 border-r">
                    {item?.projectId && item?.projectId?.length > 0
                      ? item?.projectId
                          ?.map((project) => project?.title)
                          .join(", ")
                      : "N/A"}
                  </td>
                  <td className="py-2 px-2 border-r">
                    {startCase(item?.title)}
                  </td>
                  <td className="py-2 px-2 border-r">{item?.titleAr}</td>
                  <td className="py-2 px-2 border-r">
                    {item?.category?.join(", ").toUpperCase()}
                  </td>
                  <td className="py-2 px-2 border-r text-right">
                    {helper.dateFormat(item?.createdAt)}
                  </td>
                  <td className="py-2 px-2 border-r text-right">
                    {helper.dateFormat(item?.updatedAt)}
                  </td>
                  {(manager?.add || user?.role === "admin") && (
                    <td className="py-2 px-2 border-r text-center">
                      <label
                        className="inline-flex relative items-center cursor-pointer"
                        title={`${
                          item?.status === "active" ? "Active" : "Inactive"
                        }`}
                      >
                        <input
                          type="checkbox"
                          className="sr-only peer"
                          checked={item?.status === "active"}
                          onChange={(e) =>
                            helper.alertFunction(
                              `Are you sure want to ${
                                e.target.checked ? "active" : "inactive"
                              } ${item.title}?`,
                              item,
                              handelStatusChange,
                            )
                          }
                          // onChange={(e) => handelStatusChange(item)(e)}
                        />
                        <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                      </label>
                    </td>
                  )}
                  {(manager?.add || user?.role === "admin") && (
                    <td className="py-4 px-6 border-l">
                      <div className="">
                        <ul className="flex justify-center">
                          <li
                            onClick={() => handelEdit(item)}
                            className="px-2 py-2 hover:bg-white hover:text-LightBlue"
                          >
                            <button title={t("O_EDIT")}>
                              {" "}
                              <AiFillEdit className="w-5 h-5 text-slate-600" />
                            </button>
                          </li>

                          {(manager?.delete || user?.role === "admin") && (
                            <li
                              onClick={(e) =>
                                helper.alertFunction(
                                  `Are you sure want to delete ${item.title}?`,
                                  item,
                                  handelDelete,
                                  true,
                                )
                              }
                              // onClick={() => handelDelete(item)}
                              className="px-2 py-2 hover:bg-white hover:text-LightBlue"
                            >
                              <button title={t("O_DELETE")}>
                                {" "}
                                <AiFillDelete className="w-5 h-5 text-red-600" />{" "}
                              </button>
                            </li>
                          )}
                        </ul>
                      </div>
                    </td>
                  )}
                </tr>
              ))}
            {isEmpty(FAQs) && (
              <tr className="bg-white text-center border-b dark:bg-gray-800 dark:border-gray-700">
                <td className="py-2 px-2 border-r" colSpan={6}>
                  {t("O_NO_RECORD_FOUND")}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {deleteFAQsModal ? (
        <DeleteFAQsModal
          open={deleteFAQsModal}
          onChangeHandler={unitsModalChangeHandler}
          selectedFAQs={selectedFAQs}
        />
      ) : null}
    </div>
  );
};

function DeleteFAQsModal({ open, selectedFAQs, onChangeHandler }) {
  const { t } = useTranslation();
  if (open)
    return (
      <div className="modal">
        <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
          <div className="relative my-6  w-full max-w-[1150px] mx-auto">
            <div className="sm:py-4 sm:px-2 py-8 px-7 ">
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                <div className="flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                  <h3 className="text-xl font-semibold">
                    Please confirm{" "}
                    <span className="text-red-500">deleting</span> FAQs
                  </h3>
                  <button
                    className=" ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none"
                    onClick={() => onChangeHandler(false)}
                  >
                    <span className=" text-[#B8BBBF]  text-4xl " title="Close">
                      ×
                    </span>
                  </button>
                </div>

                <div className="overflow-x-auto relative border m-3">
                  <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
                    <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
                      <tr>
                        <th scope="col" className="py-3 px-6">
                          {t("PROJECT")}
                        </th>
                        <th scope="col" className="py-3 px-6">
                          {t("FAQS_TITLE")}
                        </th>
                        <th scope="col" className="py-3 px-6">
                          {t("FAQS_TITLE") + t("O_ARABIC")}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedFAQs &&
                        selectedFAQs?.map((item) => {
                          return (
                            <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                              <td className="py-2 px-2 border-r">
                                {item?.projectId && item?.projectId?.length > 0
                                  ? item?.projectId
                                      ?.map((project) => project?.title)
                                      .join(", ")
                                  : "N/A"}
                              </td>
                              <td className="py-2 px-2 border-r">
                                {startCase(item?.title)}
                              </td>
                              <td className="py-2 px-2 border-r">
                                {item?.titleAr}
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
                <div className="flex items-center gap-4 justify-end mx-8 my-4">
                  <button
                    onClick={() => onChangeHandler(false)}
                    className="bg-gray-500 text-sm px-8 mb-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-gray-600 sm:w-auto w-1/2"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() => onChangeHandler(true)}
                    className="bg-red-500 text-sm px-8 mb-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-red-600 sm:w-auto w-1/2"
                  >
                    Confirm
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="opacity-25 fixed inset-0 z-40 bg-black" />
      </div>
    );
}

export default Table;
